import styled from 'styled-components';

import { Card } from '@dreryk/react-components';

export const StyledTooltipCard = styled(Card)`
   display: flex;
   flex-direction: column;
   gap: 16px;
   padding: 8px 12px;
`;
StyledTooltipCard.displayName = 'StyledTooltipCard';
